import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import BKimg from "../../../../assets/imgs/class/bk.gif";
import online from "../../../../assets/imgs/online.gif";
import offline from "../../../../assets/imgs/offline.gif";
import "./players.scss";

import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import Joi from "joi";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { checkClass } from "../../../tools/checkClass";
import { Link } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import useMediaQuery from "@mui/material/useMediaQuery";
import Scrollto from "../../../tools/scrollTo";
import { useLang } from "../../../../i18n/LangContext";

const Players = ({ user }) => {
  const dispatch = useDispatch();
  const { t } = useLang();

  const [usernameSend, setUsername] = useState(user.data.username);
  const [creditsSend, setCreditsSend] = useState();
  const [receiverUsername, setReceiverUsername] = useState("");

  const [formSend, setFormSend] = useState(false);
  const [loader, setLoader] = useState(false);

  const schema = {
    usernameSend: Joi.string().min(3).max(10).required(),
    receiverUsername: Joi.string().min(3).max(10).required(),
    creditsSend: Joi.number().min(1).required(),
  };

  const classes = useStyles();
  const responsive = useMediaQuery("(max-width:1500px)");

  const goTo = (to) => {
    window.scrollTo(0, to);
  };

  return (
    <div className="containerCenterProfile">
      <Scrollto position={200} />
      <h1 className="titleProfileCenter">
        <span>{t("characters")}</span>
      </h1>
      {!user.data.data[1].players.length ? (
        <div
          style={{
            color: "var(--mu-text-muted)",
            textAlign: "center",
            padding: "24px 8px",
          }}
        >
          {t("no_characters")}
        </div>
      ) : (
        <div className="players-table-scroll">
          <table className="players">
            <thead>
              <tr>
                <th>#</th>
                <th>{t("col_name")}</th>
                <th>{t("col_level")}</th>
                <th>{t("col_resets")}</th>
                {!responsive && (
                  <>
                    <th>{t("col_strength")}</th>
                    <th>{t("col_agility")}</th>
                    <th>{t("col_vitality")}</th>
                    <th>{t("col_energy")}</th>
                  </>
                )}
                <th>{t("col_status")}</th>
              </tr>
            </thead>
            <tbody>
              {user.data.data[1].players &&
                user.data.data[1].players.map((player, i) => (
                  <tr key={player.Name}>
                    <td>
                      <Link
                        to={`/player/playerMenu/${player.Name}`}
                        onClick={() => goTo(500)}
                        aria-label={`Manage ${player.Name}`}
                      >
                        <SettingsIcon fontSize="small" />
                      </Link>
                    </td>
                    <td>
                      <span>
                        <img
                          className="imgClass"
                          src={checkClass(player.Class)}
                          alt=""
                        />

                        {player.Name}
                      </span>
                    </td>
                    <td>{player.cLevel}</td>

                    <td>{player.Reset}</td>

                    {!responsive && (
                      <>
                        <td>{player.Strength}</td>
                        <td>{player.Dexterity}</td>
                        <td>{player.Vitality}</td>
                        <td>{player.Energy}</td>
                      </>
                    )}
                    <td>
                      {user.data.data[1]?.status == 1 ? (
                        <img src={online} alt="" />
                      ) : (
                        <img src={offline} alt="" />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "white",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
  },
});
export default Players;
